import { useCallback } from "react";

import { PasswordExpiredDialogConnector } from "@features/authentication";
import { useGroupErrorToast } from "@features/errors/hooks/use-group-error-toast";
import {
  Outlet,
  createRootRouteWithContext,
  useNavigate,
} from "@tanstack/react-router";

import { TwoFaGuard } from "@app/ui/two-fa-guard";

import type { RouterContext } from "../types";

import { Route as ResetPasswordRoute } from "./_public/password-reset";
import { Route as SignInRoute } from "./_public/sign-in";

const RootNavigator = () => {
  const navigate = useNavigate();

  useGroupErrorToast([
    "REQUEST_INVALID",
    "AUTHORIZATION_ERROR",
    "NOT_FOUND_ERROR",
    "ILLEGAL_ACCESS_ERROR",
    "DATA_CONFLICT_ERROR",
    "VALIDATION_ERROR",
    "REQUEST_RATE_LIMIT_ERROR",
    "UNEXPECTED_ERROR",
    "BAD_GATEWAY_ERROR",
  ]);

  const handleResetPassword = useCallback(() => {
    navigate({ to: ResetPasswordRoute.fullPath });
  }, [navigate]);

  const handleAuthorize = useCallback(() => {
    navigate({ to: SignInRoute.fullPath });
  }, [navigate]);

  return (
    <TwoFaGuard>
      <Outlet />
      <PasswordExpiredDialogConnector
        onAuthorize={handleAuthorize}
        onResetPassword={handleResetPassword}
      />
    </TwoFaGuard>
  );
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootNavigator,
});
